import PropTypes from 'prop-types';
import { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@material-ui/core';
import { ExpandMore, Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanelTitle from 'components/common/ExpansionPanelTitle';
import IconButton from '@material-ui/core/IconButton';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

const useStyles = makeStyles((theme) => ({
  details: {
    color: theme.palette.text.primary,
  },
}));

/**
 * Masks a loan number unless showFull is true.
 * @param {string|number} value - The loan number to mask.
 * @param {boolean} [showFull=false] - If true, returns the full value unmasked.
 * @returns {string}
 */
function maskLoanNumber(value, showFull = false) {
  if (!value) return '';
  if (showFull) return String(value);
  const str = String(value);
  if (str.length <= 4) return str;
  return '*'.repeat(str.length - 4) + str.slice(-4);
}

const GuestProfile = ({ loanNumber, loanType }) => {
  const [expanded, setExpanded] = useState(true);
  const [showFullLoanNumber, setShowFullLoanNumber] = useState(false);
  const classes = useStyles();

  const handleChange = (event, expanded) => {
    setExpanded(expanded);
  };

  const handleToggleLoanNumber = () => {
    setShowFullLoanNumber((prev) => !prev);
  };

  return (
    <Accordion expanded={expanded} id="guest-profile" onChange={handleChange}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Grid
          alignItems="center"
          container
          justifyContent="space-between"
          wrap="nowrap"
        >
          <Grid item style={{ display: 'flex', alignItems: 'center' }}>
            <AssignmentIndIcon
              style={{
                fontSize: 34,
                marginRight: 8,
                background: 'none',
                color: '#6d7073',
                padding: 2,
              }}
            />
            <ExpansionPanelTitle
              expanded={expanded}
              title={<span style={{ fontSize: 28 }}>Guest Profile</span>}
            />
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Typography
          variant="body1"
          component="span"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <span style={{ marginRight: 8 }}>
            <p>Payments to {loanType} Loan:</p>
          </span>
          <span style={{ marginRight: 8 }}>
            {loanNumber ? (
              maskLoanNumber(loanNumber, showFullLoanNumber)
            ) : (
              <em>No loan number</em>
            )}
          </span>
          <IconButton
            aria-label={
              showFullLoanNumber ? 'Hide loan number' : 'Show loan number'
            }
            onClick={handleToggleLoanNumber}
            size="small"
            style={{ padding: 2, verticalAlign: 'middle' }}
          >
            {showFullLoanNumber ? (
              <VisibilityOff fontSize="small" />
            ) : (
              <Visibility fontSize="small" />
            )}
          </IconButton>
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

GuestProfile.propTypes = {
  loanNumber: PropTypes.string.isRequired,
  loanType: PropTypes.string.isRequired,
};

export default GuestProfile;
